import module from 'module';
import templateUrl from './denomination-serial-numbers.template.html';
import _ from 'lodash';

class DenominationSerialNumbers {
  constructor($scope, http, authentication) {
    this.$scope = $scope;
    this.http = http;
    this.authentication = authentication;
  }
  
  async $onInit() {
    this.userId = this.authentication.context.id;
    this.$scope.$watch('$ctrl.currency', async () => await this.initializeSerialNumbersInput());
  }

  async initializeSerialNumbersInput() {
    if (!this.currency || this.isLoading) {
      return;
    }

    try {
      // Set everything to null and re-evaluate.
      this.serialNumberCashInConfig = null;
      this.serialNumberCashOutConfig = null;
      this.noteList = null;
      this.branchSummaryMap = {};
      this.isLoading = true;

      const branchSummary = await this.http.get(`/currencies/denomination/users/${this.userId}?currencyId=${this.currency.id}`, {}, {nxLoaderText: 'Loading serial numbers'}).toPromise();
      
      branchSummary.summary.forEach(s => {
        this.branchSummaryMap[s.currencyUnitId] = s.serialNumbers === null || !s.serialNumbers.length ? [] : s.serialNumbers.map(serialNumber => ({serialNumber}));
      });

      this.noteList = _.reverse(_.sortBy(this.currency.units.filter(unit => unit.type === 'NOTE'), (a) => a.unitValue));

      this.serialNumberCashInConfig = {
        placeholder: 'Enter serial numbers',
        persist: false,
        createOnBlur: false,
        plugins: ['remove_button'],
        create: (input) => {
          input = input.toUpperCase();
          return {
            value: input,
            text: input
          };
        },
        createFilter: (serialNumber) => {
          let returnValue = true;
          this.noteList.forEach(note => {
            if (note.incomingSerialNumbers && note.incomingSerialNumbers.length) {
              note.incomingSerialNumbers.forEach(sn => {
                if (serialNumber.toUpperCase() === sn.toUpperCase()) {
                  returnValue = false;
                }
              });
            }
          });
          
          return returnValue;
        }
      };

      this.serialNumberCashOutConfig = {
        valueField: 'serialNumber',
        labelField: 'serialNumber',
        searchField: ['serialNumber'],
        plugins: ['remove_button'],
        placeholder: 'Select serial numbers',
      };
    } catch (e) {
      // Do nothing.
    } finally {
      this.isLoading = false;
    }
  }

  isSerialNumbersCountValid(denominationBundle, currencyUnitId, serialNumbers) {
    const unitDenomination = (denominationBundle.units.find(u => u.currencyUnitId === currencyUnitId) || {});
    const expectedDenominationCount = unitDenomination.count || 0;
    const detectedSerialNumbersCount = (serialNumbers || []).length;
    return expectedDenominationCount === detectedSerialNumbersCount;
  }
}

module.component('denominationSerialNumbers', {
  templateUrl: templateUrl,
  bindings: {
    'currency': '<',
    'objectRef': '=',
    'isLoading': '='
  },
  controller: DenominationSerialNumbers
});